<template>
  <div :class="$style.modalContent">
    <ModalHeader
      :handleClose="handleClose"
      headerText="Create Saved View"
      :showClose="true"
    />
    <div :class="$style.modalBody">
      <p>
        Save your current view for quick access in the future.
      </p>
      <InputOptionalValidation
        v-model="name"
        v-validate="'required|unique|nohtml'"
        autofocus
        :class="$style.input"
        label="Name"
        name="Name"
        @enter="handleSave"
      />
      <div
        v-if="!quickPickDate"
        :class="$style.disclaimer"
      >
        Note: Saving a view that uses a custom time range selection will default to the last hour.
      </div>
    </div>
    <ModalFooter
      cancelText="cancel"
      :enableMainAction="!!name"
      :handleClose="handleClose"
      :handleMainAction="handleSave"
      mainActionText="save"
    />
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapState } from 'vuex';
import InputOptionalValidation from 'components/FormValidation/Input.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';
import ModalFooter from 'components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'components/Modal/ModalComponents/ModalHeader.vue';

const insightsEventModule = StoreModuleMap[ItemTypeConsts.insightsEvent];

export default {
  name: 'ActivityLogCreateViewModal',
  components: {
    InputOptionalValidation,
    ModalFooter,
    ModalHeader,
  },

  props: {
    handleContinue: {
      type: Function,
      default: () => {},
    },
  },

  data: () => ({
    name: '',
  }),

  computed: {
    ...mapState(insightsEventModule, [
      'quickPickDate',
      'savedViews',
    ]),
  },

  beforeMount() {
    // Add "unique name" validator
    this.$validator.extend('unique', {
      getMessage: 'A Saved View with this name already exists.',
      validate: value => !this.savedViews.map(d => d.name).includes(value),
    });

    // Add validator to reject special characters (to prevent HTML injection)
    this.$validator.extend('nohtml', {
      getMessage: 'Special characters (<>%$/) are not allowed.',
      validate: value => !value.match(/[<>%$\\]/),
    });
  },

  methods: {
    handleClose() {
      ModalEventBus.close();
    },

    async handleSave() {
      await this.$validator.validate('Name');
      if (this.v2Errors.any()) return;

      this.handleContinue(this.name);
    },
  },
};
</script>

<style module>
@import '../../../components/Modal/css/ModalStyles.css';

.modalBody {
  font-size: 1.07rem;
  padding-top: 0;
}

.input { margin: 20px 0 10px; }

.disclaimer {
  font-size: 0.92rem;
}
</style>
